
namespace Gamification.Gamification {
    export class DispositiviColumns {
        static columnsKey = 'Gamification.Dispositivi';
    }
}